(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collapsible-row-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    nativeCustomLinks();
  });

  async function nativeCustomLinks(){
    document.querySelectorAll('.native-custom.quick-links').forEach(quickLinks => {
      quickLinks.addEventListener('click', function (event){
        let quickLink = event.target.classList.contains('quick-links__link') ? event.target : event.target.closest('.quick-links__link');
        if(quickLink){
          quickLinks.querySelectorAll('.quick-links__link.active').forEach(child => {
            child.classList.remove('active');
          });
          quickLink.classList.add('active');
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-text-block"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const texts = document.querySelectorAll('.text-block__content-wrapper');
    const images = document.querySelectorAll('.text-block__media-content');
    const section = document.querySelector('.text-block');
    const navHeight = document.querySelector('header')?.offsetHeight || 0;
    let sectionPosition = section.getBoundingClientRect().top + window.scrollY - navHeight;
    const windowHeight = window.innerHeight;
    let lastScroll = 0;
    let scrollBackwards = false;

    // Restore scroll position if available
    const savedScroll = sessionStorage.getItem('parallax-scrollY');
    const savedSectionPosition = sessionStorage.getItem('parallax-section-position');
    if (savedScroll && savedSectionPosition) {
      sectionPosition = Number(savedSectionPosition) || sectionPosition;
      console.log('section', sectionPosition);
      console.log('document',  document.querySelector('.text-block').getBoundingClientRect().top);
      window.scrollTo(0, parseInt(savedScroll));
    }

    // Setting first block as a placeholder
    texts[0].style.position = 'static';
    texts[0].style.opacity = 1;
    texts[0].style.transform = 'none';
    texts[0].style.transition = 'none';

    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      const lastBlock = sectionPosition + (windowHeight * (texts.length - 1));
      scrollBackwards = scrollY < lastScroll;

      // Save scroll position
      sessionStorage.setItem('parallax-scrollY', scrollY);
      sessionStorage.setItem('parallax-section-position', sectionPosition);

      // Start parallax effect
      if (scrollY >= sectionPosition) {
        texts.forEach((text, index) => {
          text.style.position = 'fixed';
          text.style.opacity = 0;
          text.style.transform = 'translateY(-50%)';
          text.style.transition = 'opacity 0.6s ease-in-out';

          const triggerPoint = sectionPosition + (index * windowHeight);
          const isLast = index === texts.length - 1;
          const endOffset = isLast ? windowHeight * 0.75 : windowHeight;

          if (scrollY >= triggerPoint && scrollY < triggerPoint + endOffset) {
            text.style.position = 'fixed';
            text.style.opacity = 1;
          } else {
            text.style.opacity = 0;
            text.style.position = 'static';
          }
        });
      }

      // Removing extra space at the top when reaching last block
      if (scrollY > lastBlock) {
        images[0].style.top = 0;
      }

      // Setting first block as a placeholder again when scrolling backwards
      if (scrollBackwards && scrollY <= (sectionPosition - 50)) {
        texts[0].style.position = 'static';
        texts[0].style.opacity = 1;
        texts[0].style.transform = 'none';
        texts[0].style.transition = 'none';
        images[0].style.top = '20vh';
      }

      // Update lastScroll value
      lastScroll = scrollY <= 0 ? 0 : scrollY;
    });
    window.dispatchEvent(new Event('scroll'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customer-login"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('redirect_from') === 'track-order-page') {
      const messageContainer = document.createElement('p');
      messageContainer.className = 'track-order-message';
      messageContainer.innerText = 'Please log in to track your order.';
      const containers = document.querySelectorAll('#login__track-order-message-container');
      if (containers.length > 0) {
        containers.forEach((container, i) => {
          container.appendChild(i === 0 ? messageContainer : messageContainer.cloneNode(true));
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
